import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface FarmIconProps extends SvgIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function FarmIcon({
  htmlColor,
  fontSize = "medium",
  ...props
}: FarmIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" fontSize={fontSize} {...props}>
      <path
        d="M22 8.99953V14.9995C22 17.4995 21.5 19.2495 20.38 20.3795L14 13.9995L21.73 6.26953C21.91 7.05953 22 7.95953 22 8.99953Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M21.73 6.27L6.26999 21.73C3.25999 21.04 2 18.96 2 15V9C2 4 4 2 9 2H15C18.96 2 21.04 3.26 21.73 6.27Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M20.38 20.38C19.25 21.5 17.5 22 15 22H9.00003C7.96003 22 7.06002 21.91 6.27002 21.73L14 14L20.38 20.38Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.24002 7.9807C6.92002 5.0507 11.32 5.0507 12 7.9807C12.39 9.7007 11.31 11.1607 10.36 12.0607C9.67001 12.7207 8.58003 12.7207 7.88003 12.0607C6.93003 11.1607 5.84002 9.7007 6.24002 7.9807Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M9.0946 8.69922H9.10359"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
